// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__39h0G","notes":"Notes_notes__2Qvfk"};